// Country mapping: phone code to ISO country code
export const phoneCodeToCountry = {
  '1': 'us',    // United States
  '44': 'gb',   // United Kingdom  
  '49': 'de',   // Germany
  '33': 'fr',   // France
  '39': 'it',   // Italy
  '34': 'es',   // Spain
  '31': 'nl',   // Netherlands
  '46': 'se',   // Sweden
  '47': 'no',   // Norway
  '45': 'dk',   // Denmark
  '358': 'fi',  // Finland
  '41': 'ch',   // Switzerland
  '43': 'at',   // Austria
  '32': 'be',   // Belgium
  '351': 'pt',  // Portugal
  '30': 'gr',   // Greece
  '48': 'pl',   // Poland
  '420': 'cz',  // Czech Republic
  '421': 'sk',  // Slovakia
  '36': 'hu',   // Hungary
  '40': 'ro',   // Romania
  '359': 'bg',  // Bulgaria
  '385': 'hr',  // Croatia
  '386': 'si',  // Slovenia
  '372': 'ee',  // Estonia
  '371': 'lv',  // Latvia
  '370': 'lt',  // Lithuania
  '972': 'il',  // Israel ← This is the important one!
  '20': 'eg',   // Egypt
  '971': 'ae',  // UAE
  '966': 'sa',  // Saudi Arabia
  '965': 'kw',  // Kuwait
  '974': 'qa',  // Qatar
  '973': 'bh',  // Bahrain
  '968': 'om',  // Oman
  '962': 'jo',  // Jordan
  '961': 'lb',  // Lebanon
  '963': 'sy',  // Syria
  '964': 'iq',  // Iraq
  '98': 'ir',   // Iran
  '90': 'tr',   // Turkey
  '91': 'in',   // India
  '86': 'cn',   // China
  '81': 'jp',   // Japan
  '82': 'kr',   // South Korea
  '61': 'au',   // Australia
  '64': 'nz',   // New Zealand
  '27': 'za',   // South Africa
  '55': 'br',   // Brazil
  '54': 'ar',   // Argentina
  '52': 'mx',   // Mexico
  '51': 'pe',   // Peru
  '56': 'cl',   // Chile
  '57': 'co',   // Colombia
  '58': 've',   // Venezuela
};

// Country name to ISO code mapping for smart defaults
export const countryNameToISO = {
  'Israel': 'il',
  'United States': 'us',
  'United Kingdom': 'gb',  
  'Germany': 'de',
  'France': 'fr',
  'Italy': 'it',
  'Spain': 'es',
  'Netherlands': 'nl',
  'Sweden': 'se',
  'Norway': 'no',
  'Denmark': 'dk',
  'Finland': 'fi',
  'Switzerland': 'ch',
  'Austria': 'at',
  'Belgium': 'be',
  'Portugal': 'pt',
  'Greece': 'gr',
  'Poland': 'pl',
  'Czech Republic': 'cz',
  'Slovakia': 'sk',
  'Hungary': 'hu',
  'Romania': 'ro',
  'Bulgaria': 'bg',
  'Croatia': 'hr',
  'Slovenia': 'si',
  'Estonia': 'ee',
  'Latvia': 'lv',
  'Lithuania': 'lt',
  'Egypt': 'eg',
  'UAE': 'ae',
  'Saudi Arabia': 'sa',
  'Kuwait': 'kw',
  'Qatar': 'qa',
  'Bahrain': 'bh',
  'Oman': 'om',
  'Jordan': 'jo',
  'Lebanon': 'lb',
  'Syria': 'sy',
  'Iraq': 'iq',
  'Iran': 'ir',
  'Turkey': 'tr',
  'India': 'in',
  'China': 'cn',
  'Japan': 'jp',
  'South Korea': 'kr',
  'Australia': 'au',
  'New Zealand': 'nz',
  'South Africa': 'za',
  'Brazil': 'br',
  'Argentina': 'ar',
  'Mexico': 'mx',
  'Peru': 'pe',
  'Chile': 'cl',
  'Colombia': 'co',
  'Venezuela': 've',
};

// Helper function to get country ISO code from phone code
export const getCountryFromPhoneCode = (phoneCode) => {
  const cleanCode = phoneCode?.toString().replace('+', '');
  return phoneCodeToCountry[cleanCode] || 'us'; // Default to US
};

// Helper function to get country ISO code from country name
export const getCountryFromName = (countryName) => {
  return countryNameToISO[countryName] || null;
};

// Helper function to determine smart default country
export const getSmartDefaultCountry = (user) => {
  // 1. If user has existing phone with country code, use that
  if (user?.country_code) {
    const fromPhoneCode = getCountryFromPhoneCode(user.country_code);
    if (fromPhoneCode !== 'us') return fromPhoneCode; // Only if not default
  }
  
  // 2. If user has country in profile, use that
  if (user?.country) {
    const fromCountryName = getCountryFromName(user.country);
    if (fromCountryName) return fromCountryName;
  }
  
  // 3. Default fallback
  return 'us';
};